/* eslint-disable @typescript-eslint/explicit-function-return-type */
import type {Routes} from "@angular/router";
import {PermissionId} from "../../models/users/Permission";
import {UserAccountType} from "../../models/users/User";
import {hasPermissions, hasUserTypes, isLoggedIn} from "../../services/guards/permission-guard";

export const i18nRoutes = [
  {
    path: "i18n",
    canActivateChild: [isLoggedIn, hasUserTypes(UserAccountType.Admin)],
    children: [
      {
        path: "languages",
        children: [
          {
            path: "",
            loadComponent: () => import("./languages/list/languages-list").then(m => m.LanguagesList),
          },
          {
            path: ":languageCode",
            children: [
              {
                path: "translations",
                canActivate: [hasPermissions(PermissionId.EditTranslations)],
                loadComponent: () => import("./languages/translations/language-translations").then(m => m.LanguageTranslations),
              },
            ],
          },
        ],
      },
      {
        path: "countries",
        children: [
          {
            path: "",
            loadComponent: () => import("./countries/list/countries-list").then(m => m.CountriesList),
          },
          {
            path: ":countryCode",
            children: [
              {
                path: "translations",
                canActivate: [hasPermissions(PermissionId.EditTranslations)],
                loadComponent: () => import("./countries/translations/country-translations").then(m => m.CountryTranslations),
              },
            ],
          },
        ],
      },
    ],
  },
] as const satisfies Routes;
